import React from "react";

const Footer = () => {
  return (
    <div className="login-footer">
      <div className="login-footer-inner">
        <div className="login-footer-brand">
          <img alt="A-LIGN SOC certification badge" src="/assets/Img/A-LIGN-SOC.png" />
          <div>
            <img alt="WorkFINITY" src="/assets/Img/wflogoblack.png" />
            <span>Delivered by IPCS &reg;</span>
          </div>
        </div>

        <p className="login-footer-license">
          This software is licensed to the user. Use of the software constitutes acceptance of the terms and conditions of the License Agreement.
          <br />
          &copy;IPCS&reg;. &copy;WorkFINITY&reg;. All rights reserved. Under US Patent Protection.
        </p>

        <a className="login-footer-support" href="mailto:Support@workfinity.com">
          <i className="fa fa-life-ring" aria-hidden="true"></i>
          <span>
            Customer Support
            <strong>Support@workfinity.com</strong>
          </span>
        </a>
      </div>
    </div>
  );
};

export default Footer;
